import React from 'react';
import { Box, Typography } from '@mui/material';
// Removido fallback hardcoded
import { useBranding } from '../context/BrandingContext';

/**
 * Componente de logo do cartório, reutilizável em toda a aplicação
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.variant='default'] - Variante do logo: 'default', 'small', 'large'
 * @param {string} [props.alignment='center'] - Alinhamento do logo: 'center', 'left', 'right'
 * @param {Object} [props.sx] - Estilos adicionais para o componente Box externo
 */
const CartorioLogo = ({ variant = 'default', alignment = 'center', sx = {} }) => {
  const { branding, sizing, textSizing, isTitleVisible, isSubtitleVisible } = useBranding();
  // Configurações baseadas na variante
  const getLogoSize = () => {
    switch (variant) {
      case 'small':
        return { width: '30px', height: '30px' };
      case 'large':
        return { width: '60px', height: '60px' };
      default:
        return { width: '40px', height: '40px' };
    }
  };

  const getFontSize = () => {
    switch (variant) {
      case 'small':
        return { title: '18px', subtitle: '11px' };
      case 'large':
        return { title: '26px', subtitle: '15px' };
      default:
        return { title: '22px', subtitle: '13px' };
    }
  };

  // Configurações baseadas no alinhamento
  const getAlignment = () => {
    switch (alignment) {
      case 'left':
        return { textAlign: 'left', alignItems: 'flex-start' };
      case 'right':
        return { textAlign: 'right', alignItems: 'flex-end' };
      default:
        return { textAlign: 'center', alignItems: 'center' };
    }
  };

  const logoSize = getLogoSize();
  const fontSize = getFontSize();
  const alignProps = getAlignment();

  // Seleciona logo do branding para o painel, com fallback
  const panelLogo = branding?.assets?.panel?.main;
  const panelSize = sizing?.panel?.main;
  const title = branding?.displayName;
  const subtitle = branding?.displaySubtitle;
  const panelTextSizes = textSizing?.panel || {};
  const titlePx = panelTextSizes.titlePx || parseInt(fontSize.title, 10);
  const subtitlePx = panelTextSizes.subtitlePx || parseInt(fontSize.subtitle, 10);

  return (
    <Box 
      sx={{ 
        p: 1, 
        display: 'flex', 
        justifyContent: alignment === 'center' ? 'center' : 'flex-start',
        flexDirection: 'column',
        ...alignProps,
        ...sx
      }}
    >
      {/* Renderiza a imagem apenas se existir URL configurada */}
      {panelLogo && (
        <img 
          src={panelLogo} 
          alt={title} 
          style={{ 
            width: panelSize?.width ? `${panelSize.width}px` : logoSize.width, 
            height: panelSize?.height ? `${panelSize.height}px` : logoSize.height,
            objectFit: 'contain'
          }} 
        />
      )}
      {isTitleVisible('panel') && title && (
        <Typography 
          variant="h5" 
          component="div" 
          sx={{ 
            color: '#2c3e50', 
            fontWeight: 700, 
            letterSpacing: '0.1em', 
            mb: '-7px', 
            p: 0, 
            fontSize: `${titlePx}px`
          }} 
        >
          {title}
        </Typography>
      )}
      {isSubtitleVisible('panel') && subtitle && (
        <Typography 
          variant="subtitle2" 
          component="div" 
          sx={{ 
            color: '#2c3e50', 
            fontSize: `${subtitlePx}px`
          }} 
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default CartorioLogo; 